<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <h2 class="text-lg font-medium mr-auto">出版刊物</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <button v-show="!isEditing" class="button text-white bg-theme-1 shadow-md mr-2 flex items-center" @click="grid.addNewRow">
          <FontAwesome icon="plus" type="fas" class="w-4 h-4 mr-1" />
          新增
        </button>
        <div v-show="!grid.isEditing && grid.isRowSelected" id="batch-dropdown" class="dropdown ml-auto mr-2 sm:ml-0">
          <button
            class="dropdown-toggle button px-2 box bg-blue-500 text-white flex items-center"
          >
            <FontAwesome icon="tasks" type="fas" class="w-4 h-4 mr-1" />
            群組操作
          </button>
          <div class="dropdown-box">
            <div class="dropdown-box__content box dark:bg-dark-1 p-2 w-32">
              <span 
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                @click="grid.removeSelectedRows"
              >
                <FontAwesome icon="trash" type="fas" class="w-4 h-4 mr-2" /> 刪除
              </span>
              <!-- <span 
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                @click="grid.onPrint({ mode: 'selected' })"
              >
                <FontAwesome icon="print" type="fas" class="w-4 h-4 mr-2" /> 列印
              </span> -->
              <!-- <button
              class="dropdown-toggle button w-full sm:w-auto flex items-center border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
            >
              <FontAwesome icon="file-export" class="w-4 h-4 mr-2" /> 匯出
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button> -->
              <!-- <span 
                class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                @click="grid.onExport({ type: 'html', mode: 'selected' })"
              >
                <FontAwesome icon="file" type="fas" class="w-4 h-4 mr-2" /> 匯出 HTML
              </span> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <div class="flex flex-col sm:flex-row sm:items-end xl:items-start">
        <div class="xl:flex sm:mr-auto">
          <div class="sm:flex items-center ml-1 sm:mr-2 mt-2 xl:mt-0">
            <input
              type="text"
              class="input w-full sm:w-40 xxl:w-full mt-2 sm:mt-0 border"
              v-model.trim="grid.keyword"
              placeholder="請輸入關鍵字"
              @keyup.enter="grid.refresh"
            />
          </div>
          <div class="mt-2 xl:mt-0">
            <button
              type="button"
              class="button w-full sm:w-16 bg-theme-1 text-white"
              @click="grid.refresh"
            >
              搜尋
            </button>
          </div>
        </div>
        <div class="flex mt-2 sm:mt-0">
          <!-- <button
            class="button w-1/2 sm:w-auto flex items-center border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
            @click="grid.onPrint({ mode: 'curret' })"
          >
            <FontAwesome icon="print" class="w-4 h-4 mr-2" /> 列印
          </button> -->
          <div class="dropdown w-1/2 sm:w-auto ml-2">
            <!-- <button
              class="dropdown-toggle button w-full sm:w-auto flex items-center border text-gray-700 dark:bg-dark-5 dark:text-gray-300"
            >
              <FontAwesome icon="file-export" class="w-4 h-4 mr-2" /> 匯出
              <ChevronDownIcon class="w-4 h-4 ml-auto sm:ml-2" />
            </button> -->
            <div class="dropdown-box">
              <div class="dropdown-box__content box dark:bg-dark-1 p-2">
                <a
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="grid.onExport({ type: 'csv' })"
                >
                  <FontAwesome icon="file-csv" class="w-4 h-4 mr-2" /> CSV
                </a>
                <!-- <a
                  href="javascript:;"
                  class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                  @click="grid.onExport({ type: 'html' })"
                >
                  <FontAwesome icon="file" type="fas" class="w-4 h-4 mr-2" /> HTML
                </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overflow-x-auto scrollbar-hidden mt-2">
        <grid 
          ref="grid"
          v-bind="gridOptions" 
          @addNewRow="(row, callback) => { initData(row); callback(); }"
          @edit="onGridEdit"
          @modalResize="onGridModalResize"
          @BookSubmit="BookSubmit"
          @removeSelectedRows="onGridRemoveSelectedRows" 
        >
          <template #modal="{ row, submit, reset }">
            <div class="w-full text-center">
              <file-upload
                name="files"
                ref="uploader"
                extensions="gif,jpg,jpeg,png,webp"
                accept="image/png,image/gif,image/jpeg,image/webp"
                :drop="true"
                v-model="files"
                @input-filter="inputFilter"
                @input-file="inputFile"
              >
              <img
                class="border p-1 rounded"
                style="max-width:150px; max-height:200px;"
                :src="data.Picture.Uri ? data.Picture.Uri : files.length ? files[0].url : 'https://via.placeholder.com/150x200.png?text=Click%20or%20Drop%20file%20here'"
              />
            </file-upload>
              <!-- <div v-if="form.formData.Picture.Uri || files.length > 0">
                <button type="button" class="button rounded-full mr-1 mb-2 bg-theme-1 text-white" @click="deletePicture">刪除圖片</button>
              </div> -->
            </div>
            <vxe-form :title-width="100" title-align="right" v-bind="formOptions" :data="row" @reset="reset(null, data)" @submit="submit">
            </vxe-form>
          </template>
        </grid>
      </div>
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<style scoped>
  .swiper-container {
    padding-top: 5px;
    padding-bottom: 30px;
  }
</style>
<style>
  textarea {
    min-height: 140px;  
  }
  .vxe-select-option{
    max-width: 100% !important;
  }
</style>

<script>
import { onMounted } from "vue";
import CloudFun, { defineComponent, ref, reactive } from "@cloudfun/core";
import Grid from "@/cloudfun/components/Grid.vue";
import FileUpload from 'vue-upload-component';

export default defineComponent({
  components:{
    Grid,
    FileUpload
  },
  setup() {
    const model = CloudFun.current?.model;
    const uploader = ref({});
    const files = ref([]); 
    const grid = ref({});
    var data = reactive({});

    var printColumns = [
      { field: 'Name' }, 
      { field: 'Author' },
      { field: 'Price' },
      { field: 'MemberPrice' },
      { field: 'PublishedString' },
      { field: 'Ordinal' },
    ]

    const gridOptions = {
      title: '出版刊物',
      toolbarConfig: {
        custom: true,
        refresh: true,
      },
      sortConfig: { defaultSort: [{ field: 'Ordinal', orderby: 'asc' }, { field: 'CreatedTime', order: 'desc' }] },
      printConfig: { sheetName: '出版刊物清單', columns: printColumns, modes: [ 'current', 'selected', 'all' ] },
      exportConfig: { filename: '出版刊物清單', type: 'csv', types: [ 'html', 'csv' ], mode: 'all', modes: [ 'current', 'selected', 'all' ], columns: printColumns },
      columns: [
        {
          field: 'Name', title: '書名', showHeaderOverflow: true, showOverflow: true, sortable: true,
          editRender: { name: '$input', immediate: true, attrs: { type: 'text' } },
        },
        {
          field: 'Author', title: '作者', showHeaderOverflow: true, showOverflow: true, sortable: true,
          editRender: { name: '$input', immediate: true, attrs: { type: 'text' } },
        },
        {
          field: 'Price', title: '售價', width: 150, sortable: true,
        },
        {
          field: 'MemberPrice', title: '會員價', width: 150, sortable: true,
        },  
        { field: "Published", title: "發布", width: 80, sortable: true, formatter: ({ cellValue }) => { return cellValue ? '是' : '否' } },
        {
          field: 'Ordinal', title: '排序', width: 150, sortable: true,
        }, 
        
      ],
      promises: {
        query: model ? (params) => { if(params.sortings.length === 0) params.sortings.push({ column: 'Ordinal', orderby: 0 }, { column: 'CreatedTime', order: 1 }); return model.dispatch('book/query', params) }: undefined,
        queryAll: model ? () => model.dispatch('book/query', { keyword: grid.value.keyword }) : undefined,
        save: model ? (params) => model.dispatch('book/save', params) : undefined
      },
      modalConfig: { height: 700 }
    };
    const formOptions = {
      items: [
        { field: 'Name', title: '書名', span: 24, itemRender: { name: '$input', props: { placeholder: '請輸入文字' } } },
        { field: 'Author', title: '作者', span: 12, itemRender: { name: '$input', props: { placeholder: '請輸入文字' } } },
        { field: 'Ordinal', title: '排序', span: 12, itemRender: { name: '$input', props: { type: 'number', placeholder: '排序' } } },
        { field: 'Published', title: '是否發佈', span: 12, itemRender: { name: '$radio', options: [ { label: '否', value: false }, { label: '是', value: true }] } },
        { field: 'PublishDate', title: '發佈日期', span: 12, itemRender: { name: '$input', props: { type: 'date', placeholder: '發佈日期' } } },
        { field: 'Price', title: '售價', span: 12, itemRender: { name: '$input', props: { type: 'number', placeholder: '售價' } } },
        { field: 'MemberPrice', title: '會員價', span: 12, itemRender: { name: '$input', props: { type: 'number', placeholder: '會員價' } } },
        { field: 'Introduction', title: '簡介', span: 24, itemRender: { name: '$textarea', props: { autosize: { minRows: 6, maxRows: 6 }, placeholder: '內容' } } },
        {
          span: 24, align: "right", 
          itemRender: { name: '$buttons', children: [{ props: { type: 'submit', content: '確定', status: 'primary' } }, { props: { type: 'reset', content: '重置' } }] }
        }
      ], 
      rules: { 
        Name: [{ type: 'string', max: 128, required: true, message: '請輸入書名' }],
        Author: [{ type: 'string', max: 128, required: true, message: '請輸入作者' }],
        Price: [{ type: 'number', required: true, message: '售價' }],
        MemberPrice: [{ type: 'number', required: true, message: '會員價' }],
        Published: [{ required: true }],
        PublishDate: [{ required: true }],
      }
    };

    const initData = (row) => {
      row.Published = false;
      row.Enabled = false;
      row.Ordinal = 0;
      row.Price = 0;
      row.MemberPrice = 0;
      row.Picture = {
        Id: 0,
        Uri: '',
      }      
      Object.assign(data, row);
      if(files.value.length > 0) files.value = []
    }

    onMounted(() => {
      grid.value.NeedPhoto = true;
    })

    return {
      files,
      uploader,
      initData,
      grid,
      data,
      gridOptions,
      formOptions,
      baseUrl: process.env.VUE_APP_BACKEND_URL,
    };
  },
  methods: {
    onGridModalResize(size) {
      this.sliderWidth = `${size.width-100}px`;
    },
    async onGridEdit(row, callback) {
      if(this.files.length > 0) this.files = []
      const entity = row.Id ? await this.$model.dispatch('book/find', row.Id) : undefined;
      if (entity) {
        Object.assign(row, entity);
        Object.assign(this.data, row);
        if(this.data.Picture.Uri) {
          setTimeout(() => {              
            this.data.Picture.Uri = this.data.Picture.Uri + "?" + new Date().getTime();   
          }, 200);
        }
      } 
      callback();
    },
    onGridRemoveSelectedRows(rows, callback) {
      cash('#batch-dropdown').dropdown('hide');
      callback();
    },
    inputFile(newFile, oldFile, prevent) {      
      
      if (newFile && !oldFile) {
        this.$nextTick(function () {
          console.log(prevent)         
        })        
      }
      if (!newFile && oldFile) {        
      }
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(gif|jpg|jpeg|png|webp)$/i.test(newFile.name)) {          
          return prevent()
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = ''
        const URL = window.URL || window.webkitURL        
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file)
          this.data.Picture.Uri = newFile.url
        }
      }
    },
    BookSubmit(method, row, callback) {
      var obj = this.files;
      const formData = new FormData();
      if(obj.length > 0){
        formData.append("file", obj[0].file);
      }
      formData.append("json", JSON.stringify(row));
      this.$model.dispatch(`book/${method}`, formData).then(
        () => {
          CloudFun.send('info', { subject: method === 'insert' ? '新增成功' : '更新成功', content: method === 'insert' ? '出版刊物新增完成' : '出版刊物更新完成' })
        },
        failure => CloudFun.send('error', { subject: '操作失敗！', content: failure })
      ).finally(() => { 
        callback();
      });

      
    },
  },
});
</script>
